const API_BASE_URL = '/api';

interface CustomerContextResponse {
  notes?: string;
  [key: string]: unknown;
}

export async function getCustomerNotes(
  customerId: string,
  signal?: AbortSignal
): Promise<string | null> {
  const response = await fetch(
    `${API_BASE_URL}/customers/${customerId}`,
    { method: 'GET', headers: { Accept: 'application/json' }, signal }
  );

  if (!response.ok) {
    throw new Error(`Failed to fetch customer notes: ${response.status} ${response.statusText}`);
  }

  const data: CustomerContextResponse = await response.json();
  return data.notes ?? null;
}

export async function updateCustomerNotes(
  customerId: string,
  notes: string,
  signal?: AbortSignal
): Promise<void> {
  const response = await fetch(
    `${API_BASE_URL}/customers/${customerId}/notes`,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ notes }),
      signal,
    }
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({
      error: `Failed to update notes: ${response.status}`,
    }));
    throw new Error(errorData.error);
  }
}
